/**
 * Resolve the i18n key for the "N payments" badge label.
 *
 * Mirrors the plan-selection convention (see order-details-modal.tsx): Arabic
 * uses the singular form for counts >= 11, otherwise the standard plural key.
 * Reuses the existing `common.payments` strings rather than inventing new copy.
 */
export function getPaymentsLabelKey(language: string, count: number): string {
  return (language ?? "").startsWith("ar") && count >= 11
    ? "common.payments_one"
    : "common.payments";
}
